// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"166":"4baf96b2","477":"25fd6da9","821":"49d0e900"}[chunkId] + ".js";
};